/**
 * @(#)2019/6/17.
 * TextArea，可以输入所有内容的文本区域
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Basics from "../Basics";
import { Input } from "antd";
import { YxComponent, Connection } from "../../YxComponent";

/*
 * @param autosize {bool | object} 文本域的大小是否根据内容决定， 参考antd官网
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */
export let defaultProps = () => {
  return {
    children: <Input.TextArea />, //子节点
    inputParam: {},
    autosize: false,
    styleParam: {
      width: "textarea", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaultProps)
class TextArea extends YxComponent {
  productionHtml() {
    let tmpProps = this.props;
    let classParam = {
      yx_yxInput_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxTextArea_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );
    let html = Basics.html(tmpProps);
    return html;
  }
  render() {
    return this.productionHtml();
  }
}
export default TextArea;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxTextArea/yxTextArea.js